export const env = {
  REACT_APP_APIKEY: 'AIzaSyB9pcNa_jr2ZI7_nZcArhLc8kyvbntxeVk',
  REACT_APP_AUTHDOMAIN: 'aldg-contributions.firebaseapp.com',
  REACT_APP_PROJECTID: 'aldg-contributions',
  REACT_APP_STORAGEBUCKET: 'aldg-contributions.appspot.com',
  REACT_APP_MESSAGINGSENDERID: '85952117481',
  REACT_APP_APPID: '1:85952117481:web:24fc161b474dd2a3ba8e78',
  REACT_APP_MEASUREMENTID: 'G-3LXYZF9EQB'
};
